export default (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    marginBottom: theme.spacing(4),
  },
  content: {
    marginBottom: theme.spacing(4),
    width: '100%',
  },
  listItem: {
    margin: theme.spacing(1, 0),
  },
  addButtonRow: {
    width: '100%',
    textAlign: 'center',
  },
  addButtonRowHidden: {
    display: 'none',
  },
  addButton: {},
});
